import { Button, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";

// Tooltip Component
export const TooltipTrig = ({ id, children, title, customClass, placement }) => (
    <OverlayTrigger placement={placement} overlay={<Tooltip className="pdf-temp-setting-tooltip" id={id}>{title}</Tooltip>}>
        {children}
    </OverlayTrigger>
);


// Color picker Component
export const ColorPicker = ({ id, color, onColorChange, disabled }) => {
    return (
        <div className="input-group mb-0 choose-color">
            <input
                type="text"
                className="form-control"
                id={`${id}`}
                name={`${id}_Input`}
                value={color}
                onChange={(e) => onColorChange(e.target.value)}
                aria-label={`${id} palette`}
                aria-describedby={`${id}_addon`}
                placeholder="Enter Hex color value"
                disabled={disabled}
            />
            <span className="input-group-text p-0" id={`${id}_addon`}>
                <input
                    type="color"
                    className="form-control-color h-100 p-0 border-0"
                    value={color}
                    onChange={(e) => onColorChange(e.target.value)}
                    title="Choose your color"
                    disabled={disabled}
                />
            </span>
        </div>
    );
};

// Single Text Input with checkbox Component
export const SingleTextCheckbox = ({ checkboxId, checkboxLabel, isCheckboxEnabled, isCheckboxDisabled, inputId, inputValue, onValueChange, disabled, onCheckboxChange }) => {
    const handleCheckboxChange = (e) => {
        onCheckboxChange(e.target.checked);
    };

    return (
        <div className="mb-3 row row-cols-2 justify-content-between">
            <div className="col-auto">
                <div className="form-check col-form-label">
                    <input type="checkbox" className={`form-check-input ${!isCheckboxDisabled ? 'cursor-pointer' : ''}`}
                        id={checkboxId}
                        checked={isCheckboxEnabled}
                        onChange={handleCheckboxChange}
                        disabled={isCheckboxDisabled}
                    />
                    <label className={`form-check-label ${!isCheckboxDisabled ? 'cursor-pointer' : ''}`} htmlFor={checkboxId}>{checkboxLabel}</label>
                </div>
            </div>
            <div className="col-6">
                <input type="text" className="form-control"
                    id={inputId}
                    name={`${inputId}_Input`}
                    value={inputValue}
                    onChange={(e) => onValueChange(e.target.value)}
                    placeholder={`Enter ${inputValue} label text`}
                    disabled={disabled || !isCheckboxEnabled}
                />
            </div>
        </div>
    );
};

// Table settings component - Field border, font, BG colors
export const FieldColorCheckbox = ({ labelText, haveCheck, checkboxId, isCheckboxEnabled, inputColorId, inputColorValue, onValueChange, disabled, onCheckboxChange }) => {
    const handleCheckboxChange = (e) => {
        onCheckboxChange(e.target.checked);
    };

    return (
        <div className={`row ${!haveCheck ? 'justify-content-lg-between' : ''}`}>
            <label htmlFor={inputColorId} className="col-form-label pe-0 col-lg-5">{labelText}</label>
            {haveCheck ? (
                <div className="col-lg-1 pe-0 text-end">
                    <div className="form-check pt-2">
                        <input type="checkbox"
                            className="form-check-input cursor-pointer"
                            id={checkboxId}
                            checked={isCheckboxEnabled}
                            onChange={handleCheckboxChange}
                        />
                    </div>
                </div>
            ) : ('')}
            <div className="col-lg-6">
                <ColorPicker
                    id={inputColorId}
                    color={inputColorValue}
                    onColorChange={onValueChange}
                    disabled={disabled || !isCheckboxEnabled}
                />
            </div>
        </div>
    );
};

// Table settings component - Field font Size
export const FieldTextSize = ({ labelText, id, size, onValueChange }) => {
    return (
        <div className="row justify-content-lg-between">
            <label htmlFor={id} className="col-form-label col-lg-6">{labelText}</label>
            <div className="col-lg-6">
                <div className="input-group mb-0">
                    <input
                        type="text"
                        className="form-control"
                        id={`${id}`}
                        name={`${id}_Input`}
                        value={size}
                        onChange={(e) => onValueChange(e.target.value)}
                        aria-label={`${id} group`}
                        aria-describedby={`${id}_addon`}
                        placeholder="Enter size"
                    />
                    <span className="input-group-text" id={`${id}_addon`}>pt</span>
                </div>
            </div>
        </div>
    );
};

// Header & Footer Modal component
export const SimpleModal = (props) => {
    const { show, handleClose, size, modalTitle } = props;
    return (
        <Modal onClose={handleClose} size={size} show={show} onHide={handleClose} backdrop="static" keyboard={false}>
            <Modal.Header>
                <Modal.Title className="fw-normal">{modalTitle}</Modal.Title>
                <p className="btn-modal-close mb-0 ms-auto fs-5" onClick={() => handleClose()}>
                    <i className="fas fa-times text-danger text-opacity-75"></i>
                </p>
            </Modal.Header>
            <form>
                <Modal.Body>{props.children}</Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" className="py-1" onClick={handleClose}>
                        Preview
                    </Button>
                    <Button variant="outline-secondary" className="py-1" onClick={handleClose}>
                        Cancel
                    </Button>
                    <button type="reset" className="btn btn-link p-0 py-2 ms-auto text-decoration-none">Clear Content</button>
                </Modal.Footer>
            </form>
        </Modal>
    );
};